import {
  REPORTDETAILSDATA,
  REPORTDETAILSSUMMARY,
  FETCH,
  FETCH2,
  CONTACTDATAFETCH,
  SETSCHEDULEDATA,
  SETDBSCHEDULEDATA,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  // empty data field
  data: null,
  detailsData: null,
  summaryData: null,
  // API call
  fetching: false,
  fetching2: false,
  contactDataFetching: false,
}

// Checks the type of the action and returns the appropriate state
export default function reportDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case FETCH2:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching2,
      })
    case CONTACTDATAFETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        contactDataFetching: action.contactDataFetching,
      })
    case REPORTDETAILSDATA:
      return Object.assign({}, state, {
        detailsData: action.data,
      })
    case REPORTDETAILSSUMMARY:
      return Object.assign({}, state, {
        summaryData: action.data,
      })
    case SETSCHEDULEDATA:
      return Object.assign({}, state, {
        inputScheduleData: action.data,
      })
    case SETDBSCHEDULEDATA:
      return Object.assign({}, state, {
        dbScheduleData: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
